import React from "react";
import { Box } from "@mui/material";
import GIS from "../components/GIS/GIS";
import PortalUsers from "../components/Users/PortalUsers";
import Data from "../components/Data/Data";
import Settings from "../components/Settings/Settings";
import Documents from "../components/Documents/Documents";
import NewDocument from "../components/Documents/NewDocument";
import Groups from "../components/Groups/Groups";
import NewGroup from "../components/Groups/NewGroups";
import ValueChain from "../components/ValueChains/ValueChain";
import NewStats from "../components/Stats/NewStats";
import Navbar from "./Navbar";

export default function Home(props) {
  const pathname = window.location.pathname.split("/");

  return (
    <Box sx={{ display: "flex", height: "100vh", overflow: "hidden" }}>
      <Navbar />
      <Box
        sx={{
          flexGrow: 1,
          minHeight: 0,
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          p: 3,
          mt: 9,
        }}
      >
        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            overflow: "auto",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {pathname[1] === "" && <NewStats />}
          {pathname[1] === "gis" && <GIS showing={true} />}

          {pathname[1] === "portal" && pathname[2] === "Users" && (
            <PortalUsers />
          )}

          {pathname[1] === "documents" && pathname[2] === "Documents" && (
            <Documents />
          )}
          {pathname[1] === "documents" && pathname[2] === "New" && (
            <NewDocument />
          )}

          {pathname[1] === "data" && pathname[2] === "All%20Farmers" && (
            <Data
              url="/api/farmeraddress/alldata/paginated"
              title="Farmers Data"
            />
          )}

          {pathname[1] === "data" &&
            pathname[2] === "Fertilizer%20Farmers" && (
              <Data
                url="/api/farmeraddress/fertilizerdata/paginated"
                title="Farmers Data"
              />
            )}

          {pathname[1] === "groups" && pathname[2] === "List" && <Groups />}
          {pathname[1] === "groups" && pathname[2] === "New" && <NewGroup />}

          {pathname[1] === "group" && (
            <Data
              url={`/api/farmerdetails/bygroup/paginated/${pathname[3]}`}
              title={`Members of ${pathname[3]?.replaceAll("%20", " ") ?? ""}`}
              gname={pathname[3]?.replaceAll("%20", " ") ?? ""}
              gtype={pathname[2]?.replaceAll("%20", " ") ?? ""}
            />
          )}

          {pathname[1] === "valuechains" && (
            <ValueChain vc={`${pathname[2]?.replace("%20", " ") ?? ""}`} />
          )}

          {pathname[1] === "settings" && <Settings />}
        </Box>
      </Box>
    </Box>
  );
}
